module.exports = __webpack_public_path__ + "static/solvSureMedicine-96b09eebe9f0bc36b13c74d486e0d2fd.svg";